import { KoobAccordion } from '@koob/ui';
import { accordeonDetailsPolicies } from '../utils';

export default function HotelBookingPolicies({
  isLoading,
  translationData,
  policies,
}) {
  const [policy] = accordeonDetailsPolicies(translationData, policies);

  return (
    <div className="w-full">
      <KoobAccordion
        title={policy.description.displayName}
        variant="muted"
        loading={isLoading}
      >
        {policy.content}
      </KoobAccordion>
    </div>
  );
}
